import { motion } from "framer-motion";
import { Swords, RefreshCw, Map, PawPrint } from "lucide-react";
import GlitchText from "./GlitchText";
import { useLang } from "./LanguageContext";

const ease = [0.22, 1, 0.36, 1];

const META = [
  { icon: Swords, color: "#00F2FE", span: "md:col-span-7" },
  { icon: RefreshCw, color: "#F9D423", span: "md:col-span-5" },
  { icon: Map, color: "#00F2FE", span: "md:col-span-5" },
  { icon: PawPrint, color: "#F0F8FF", span: "md:col-span-7" },
];

export const Features = () => {
  const { t } = useLang();
  const cards = t("features.cards");
  return (
    <section id="features" data-testid="features-section" className="relative py-24 md:py-32 lg:py-40">
      <div className="absolute inset-0 kumiko opacity-50" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <span aria-hidden="true" className="pointer-events-none select-none absolute -top-10 right-0 font-display text-[11rem] leading-none text-white/[0.03]">精鋭</span>
        <div className="mb-16 max-w-2xl">
          <p className="text-[#00F2FE] text-xs font-bold tracking-[0.3em] mb-4">{t("features.overline")}</p>
          <h2 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-tight">
            {t("features.headingPre")} <GlitchText className="glitch-title text-[#00F2FE]">{t("features.headingGlitch")}</GlitchText>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {META.map((m, i) => {
            const Icon = m.icon;
            const card = cards[i] || { title: "", desc: "" };
            return (
              <motion.div
                key={i}
                data-testid={`feature-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, ease, delay: i * 0.08 }}
                className={`${m.span} group relative rounded-sm bg-gradient-to-b from-[#0C1326]/80 to-[#060A14]/90 backdrop-blur-md border border-[#00F2FE]/15 hover:border-[#F9D423]/60 p-8 md:p-10 overflow-hidden transition-all duration-500 hover:-translate-y-2`}
              >
                <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-20 blur-3xl transition-opacity duration-500 group-hover:opacity-40" style={{ background: m.color }} />
                <Icon size={40} style={{ color: m.color }} className="mb-6 relative" />
                <h3 className="font-display font-bold uppercase text-2xl md:text-3xl mb-3 text-white relative">{card.title}</h3>
                <p className="text-slate-400 text-sm md:text-base leading-relaxed max-w-md relative">{card.desc}</p>
                <span className="absolute top-7 right-8 font-mono-x text-xs tracking-[0.2em]" style={{ color: m.color }}>0{i + 1}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
